import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { toggleVipFeatureConfirmBox } from 'store/actions/confirmBox'
import { useCurrentUser } from 'store/api/yay/user'

export const useVipFeatureRestriction = () => {
  const dispatch = useDispatch()

  const isCurrentUserVip = useCurrentUser()?.data?.vip

  const showVipFeatureRestrictionBox = useCallback(() => {
    dispatch(toggleVipFeatureConfirmBox())
  }, [dispatch])

  return {
    showVipFeatureRestrictionBox,
    isCurrentUserVip,
  }
}
